import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxKjuaModule } from 'ngx-kjua';
import { EpgDetailsComponent } from '../../epg/epg-details/epg-details.component';
import { EpgGridComponent } from '../../epg/epg-grid/epg-grid.component';
import { PlayerOptionsComponent } from '../../player/player-options/player-options.component';
import { PlayerSeekbarComponent } from '../../player/player-seekbar/player-seekbar.component';
import { PipesModule } from '../pipes/pipes.module';
import { ErrorCodeTranslationService } from '../services/errorcode-translation/errorcode-translation.service';
import { RoutingService } from '../services/routing/routing.service';
import { ButtonMessageComponent } from './button-message/button-message.component';
import { CardComponent } from './card/card.component';
import { CardsCarouselListComponent } from './cards-carousel-list/cards-carousel-list.component';
import { CardsCarouselComponent } from './cards-carousel/cards-carousel.component';
import { CardsAspectRatioClassPipe } from './cards-carousel/pipes/cards-aspect-ratio-class.pipe';
import { ImagesAspectRatioClass } from './cards-carousel/pipes/images-aspect-ratio-class';
import { GridCarouselComponent } from './grid-carousel/grid-carousel.component';
import { IconComponent } from './icon/icon.component';
import { KeyboardComponent } from './keyboard/keyboard.component';
import { OkMessageComponent } from './ok-message/ok-message.component';
import { SideModalComponent } from './side-modal/side-modal.component';
import { TagComponent } from './tag/tag.component';

@NgModule({
  declarations: [
    CardComponent,
    IconComponent,
    TagComponent,
    CardsCarouselComponent,
    ImagesAspectRatioClass,
    CardsAspectRatioClassPipe,
    GridCarouselComponent,
    EpgGridComponent,
    EpgDetailsComponent,
    PlayerSeekbarComponent,
    PlayerOptionsComponent,
    SideModalComponent,
    KeyboardComponent,
    CardsCarouselListComponent,
    ButtonMessageComponent,
    OkMessageComponent,
  ],
  imports: [CommonModule, TranslateModule, PipesModule, NgxKjuaModule],
  providers: [ErrorCodeTranslationService, RoutingService],
  exports: [
    GridCarouselComponent,
    CardComponent,
    IconComponent,
    TagComponent,
    CardsCarouselComponent,
    CardsAspectRatioClassPipe,
    ImagesAspectRatioClass,
    EpgGridComponent,
    EpgDetailsComponent,
    PlayerSeekbarComponent,
    PlayerOptionsComponent,
    KeyboardComponent,
    CardsCarouselListComponent,
    ButtonMessageComponent,
    OkMessageComponent,
  ],
})
export class SharedComponentsModule {}
